import * as React from 'react';
import { keyBy } from 'lodash';
import { AnyObject } from '@interface/common';

export default function useEntities<Type>(list: any[], key: string = 'id', deps: any[] = []): AnyObject<Type> {
  return React.useMemo<AnyObject>(() => keyBy(list, key), deps);
};
